import { getFirebaseBackend } from "../../helpers/firebase/authUtils";
import { apiUrl } from "../../../config";
import axios from "axios";
import router from '../../router/index'
import { estPagePublique } from '@/helpers/pagesPubliques'

export const state = {
  currentUser: null,
  userProfile: {
    name: null,
    prenom:null,
    adresse: null,
    cp: null,
    email: null,
    entreprise: {
      IBAN: null,
      SWIFT_BIC: null,
      cp: null,
      email: null,
      id: null,
      lib: null,
      logo: null,
      num_tva: null,
      pays: null,
      rue: null,
      siret: null,
      tel: null,
      ville: null,
    },
    entreprise_id: null,
    id: null,

    tel: null,
    token: null,
    ville: null,
  },
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.userProfile = newValue;
  },
  SET_TOKEN_USER(state, newValue) {
    localStorage.setItem("auth", newValue);
  },
  NOTHING() {},
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
  currentUser(state) {
    return state.currentUser;
  },
  user(state) {
    return state.user;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch("validate");
  },

  updatePassword({ commit }, { data } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .put(apiUrl + "api/update-password", data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          commit("NOTHING",response);
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  // Logs in the current user.
  updateEntreprise({ commit }, { data,id } = {}) {
    // `data` est un FormData : il porte le logo du cabinet.
    //
    // Ne JAMAIS forcer "Content-Type": "application/json" ici. Depuis axios 1.x,
    // transformRequest fait : isFormData && hasJSONContentType
    //   -> JSON.stringify(formDataToJSON(data))
    // Le FormData est donc converti en objet JSON, et un File sérialisé devient
    // {} : le fichier n'est jamais envoyé, sans la moindre erreur cliente. Le
    // serveur repond alors « aucun fichier valide recu ».
    //
    // En laissant l'en-tete de cote, le navigateur pose lui-meme
    // multipart/form-data avec la frontiere qui va bien.
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/entreprise/"+id, data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          console.log("ici response", response);
          commit("NOTHING");
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  updateUser({ commit }, { data } = {}) {
    //delete data['email']

    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/user-update", data, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          console.log("ici response", response);
          commit("NOTHING");
          // commit("SET_TOKEN_USER",response.data.data.token)
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },
  Whoami({ commit }) {
    return new Promise((resolve) => {
      axios
        .get(apiUrl + "api/user-details", {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          commit("SET_CURRENT_USER", response.data.data.user);
          resolve(true);
        })
        .catch((e) => {
          localStorage.clear();
          // Depuis une page publique, on reste où on est
          if (!estPagePublique(router.currentRoute.path)) {
            router.push('/login');
          }
          console.log(e);
          //reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  // Logs in the current user.
  // Mot de passe oublié : demande d'un lien de réinitialisation.
  // eslint-disable-next-line no-unused-vars
  askPasswordReset({ commit }, { email } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          apiUrl + "api/forgot-password",
          { email: email },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then((response) => resolve(response.data))
        .catch((e) => reject(e));
    });
  },

  // Enregistrement du nouveau mot de passe depuis le lien reçu par email.
  // eslint-disable-next-line no-unused-vars
  confirmPasswordReset({ commit }, { email, token, password, password_confirmation } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          apiUrl + "api/reset-password",
          {
            email: email,
            token: token,
            password: password,
            password_confirmation: password_confirmation,
          },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then((response) => resolve(response.data))
        .catch((e) => reject(e));
    });
  },

  logIn({ commit }, { email, password } = {}) {
    let params = {
      email: email,
      password: password,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl + "api/login", params, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((response) => {
          commit("SET_CURRENT_USER", response.data.data.user);
          commit("SET_TOKEN_USER", response.data.data.token);
          resolve(true);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    });
  },

  // Déconnexion réelle : révoque le token côté API puis purge le stockage local.
  // La purge locale a toujours lieu, même si la révocation échoue (réseau coupé,
  // token déjà expiré) — sinon le bouton retour ré-affiche les données.
  logOut({ commit }) {
    const token = localStorage.getItem("auth");
    return new Promise((resolve) => {
      const clean = () => {
        localStorage.removeItem("auth");
        commit("SET_CURRENT_USER", { entreprise: {} });
        resolve(true);
      };
      if (token == null) {
        clean();
        return;
      }
      axios
        .post(apiUrl + "api/logout", {}, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then(clean)
        .catch((e) => {
          console.log(e);
          clean();
        });
    });
  },

  // register the user
  register({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch("validate");

    return getFirebaseBackend()
      .registerUser(email, password)
      .then((response) => {
        const user = response;
        commit("SET_CURRENT_USER", user);
        return user;
      });
  },

  // register the user
  // eslint-disable-next-line no-unused-vars
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch("validate");

    return getFirebaseBackend()
      .forgetPassword(email)
      .then((response) => {
        const message = response.data;
        return message;
      });
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null);
    const user = getFirebaseBackend().getAuthenticatedUser();
    commit("SET_CURRENT_USER", user);
    return user;
  },
};

// ===
// Private helpers
// ===

// function saveState(key, state) {
//     window.localStorage.setItem(key, JSON.stringify(state))
// }
